export class User {
    firstname: string;
    lastname : string;
    username: string;
    password: string;
    email: string;
    image: any;
    points: string;
    reenterpassword: string;
    isDistrictNeed: boolean;
    isUserExist: boolean;
    isUserRegistered: boolean;
    isRegistrationFeePaid : boolean ;
    isVerified : boolean ;
    paymentCode : any ;
    authorizationToken : any;
    token:string;
    subscriptionPackageId:string;
    paidSubscribeCount : string;
    _id: string;
    // user: {
    //     _id: string;
    //     username: string;
    //     firstname : string;
    //     lastname : string;
    //     image : string;
    //     email :string;
    //     points: string;
    //     isDistrictNeed: boolean
    // }

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }

    getDisplayName(){
        if(this.firstname && this.lastname) {
           return this.firstname;
        } 

        if(!this.firstname && !this.lastname) {
           return this.email;
        } 

        if(!this.firstname && this.lastname) {
           return this.lastname;
        } 
        if(this.firstname && !this.lastname) {
           return this.firstname;
        } 

        if(this.username) {
           return this.username;
        } 
        return '';
    }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/login.ts